/**
 * @desc updateUser
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.SysUserPushRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/usr/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
